import { MrbBaseListViewStore } from "mrb/core";
import { MrbTableViewStore } from "mrb/components";
import { podcastType, podcastContentType } from "common/constants";
import { mrbDefaultFormats } from "mrb/common/formatting";

class PodcastListViewStore extends MrbBaseListViewStore {
    constructor(rootStore, { routeStore }) {
        super(rootStore, {
            layoutActions: {
                createPodcastGroup: {
                    onClick: () => this.rootStore.routerStore.goTo("master.administration.podcast.create-group"),
                    authorization: null,
                    label: "ADMINISTRATION.PODCAST.LIST.BUTTONS.ADD_PODCAST_GROUP",
                    className: "c-btn c-btn--base c-btn--primary",
                },
                create: {
                    onClick: () => this.rootStore.routerStore.goTo("master.administration.podcast.create"),
                    authorization: null,
                    label: "ADMINISTRATION.PODCAST.LIST.BUTTONS.ADD_PODCAST",
                },
            },
            queryConfig: {
                orderBy: "title",
                orderDirection: "asc",
            },
        });
        this.routeStore = routeStore;

        this.setGridStore(
            new MrbTableViewStore(this.rootStore, this.queryUtility, {
                onRowClick: (node) => {
                    if (node.data.podcastType === podcastType.podcast) {
                        this.rootStore.routerStore.goTo("master.administration.podcast.preview", { id: node.data.id });
                    } else {
                        this.rootStore.routerStore.goTo("master.administration.podcast.preview-group", {
                            id: node.data.id,
                        });
                    }
                },
                columns: [
                    {
                        key: "title",
                        title: "ADMINISTRATION.PODCAST.LIST.COLUMNS.TITLE",
                        sortable: true,
                    },
                    {
                        key: "isActive",
                        title: "ADMINISTRATION.PODCAST.LIST.COLUMNS.STATUS",
                        format: {
                            type: mrbDefaultFormats.bool,
                            trueLabel: "Active",
                            falseLabel: "Inactive",
                        },
                    },
                    {
                        key: "isPremium",
                        title: "ADMINISTRATION.PODCAST.LIST.COLUMNS.PREMIUM",
                        format: {
                            type: mrbDefaultFormats.bool,
                            trueLabel: "Premium",
                            falseLabel: "Free",
                        },
                    },
                    {
                        key: "isTurnedOnByDefault",
                        title: "ADMINISTRATION.PODCAST.LIST.COLUMNS.DEFAULT",
                        format: {
                            type: mrbDefaultFormats.bool,
                            trueLabel: "Enabled",
                            falseLabel: "Disabled",
                        },
                    },
                    {
                        key: "isVisible",
                        title: "ADMINISTRATION.PODCAST.LIST.COLUMNS.VISIBLE_ON_PORTAL",
                        format: {
                            type: mrbDefaultFormats.bool,
                            trueLabel: "Visible",
                            falseLabel: "Hidden",
                        },
                    },
                    {
                        key: "podcastType",
                        title: "ADMINISTRATION.PODCAST.LIST.COLUMNS.PODCAST_TYPE",
                        format: (type) => (podcastType.podcast === type ? "Podcast" : "Podcast Group"),
                    },
                    {
                        key: "podcastContentType",
                        title: "ADMINISTRATION.PODCAST.LIST.COLUMNS.PODCAST_CONTENT_TYPE",
                        format: (type) =>
                            podcastContentType.default === type
                                ? "Default"
                                : podcastContentType.torahAnytimePlaylist === type
                                ? "TorahAnytime Playlist"
                                : "TorahAnytime",
                    },
                ],
                actions: {
                    edit: {
                        onClick: (item) => {
                            if (item.podcastType === podcastType.podcast) {
                                this.rootStore.routerStore.goTo("master.administration.podcast.edit", { id: item.id });
                            } else {
                                this.rootStore.routerStore.goTo("master.administration.podcast.edit-group", {
                                    id: item.id,
                                });
                            }
                        },
                        label: "ADMINISTRATION.PODCAST.LIST.ACTIONS.EDIT",
                        authorization: null,
                        buttonProps: {
                            className: "c-btn c-btn--sml c-btn--ghost u-mar--right--tny",
                        },
                    },
                    delete: {
                        onClick: (item) =>
                            this.rootStore.confirmDialogStore.showConfirm({
                                message: "Do you want to delete podcast?",
                                onConfirm: async () => {
                                    try {
                                        await this.routeStore.deletePodcast(item);
                                        this.queryUtility.fetch();
                                    } catch (err) {
                                        this.rootStore.notificationStore.error(
                                            "An unexpected error occurred. Unable to delete podcast.",
                                            err
                                        );
                                    }
                                },
                                yesLabel: "Delete",
                                noLabel: "Cancel",
                                description: "You won't be able to revert this action.",
                            }),
                        label: "ADMINISTRATION.PODCAST.LIST.ACTIONS.DELETE",
                        buttonProps: {
                            className: "c-btn c-btn--sml c-btn--ghost",
                        },
                    },
                },
            })
        );
    }

    find(params) {
        return this.routeStore.findPodcasts(params);
    }
}

export default PodcastListViewStore;
